import { render, staticRenderFns } from "./ConsumableEdit.vue?vue&type=template&id=4c2f4739&scoped=true&"
import script from "./ConsumableEdit.vue?vue&type=script&lang=js&"
export * from "./ConsumableEdit.vue?vue&type=script&lang=js&"
import style0 from "./ConsumableEdit.vue?vue&type=style&index=0&id=4c2f4739&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f4739",
  null
  
)

export default component.exports